import { all } from 'redux-saga/effects';
import { userSaga } from './userSaga';
import { authSaga } from './authSaga';
import { propertySaga } from './propertySaga';
import { uploadSaga } from './uploadSaga';
import { bannerSaga } from './bannerSaga';
import { tourSaga } from './tourSaga';
import { supplierSaga } from './supplierSaga';
import { orderSaga } from './orderSaga';
import { customerSaga } from './customerSaga';
import { groupSaga } from './groupSaga';
import { groupCategorySaga } from './groupCategorySaga';
import { productSaga } from './productSaga';
import { voucherSaga } from './voucherSaga';
import { roleSaga } from './roleSaga';
import { hotelSaga } from './hotelSaga';
import { generalSaga } from './generalSaga';
import { roomTypeSaga } from "./roomTypeSaga"
import { locationSaga } from "./locationSaga"
import { customPriceSaga } from "./customPriceSaga";
import { popularPlaceSaga } from "./popularPlaceSaga";
import { categorySaga } from "./categorySaga";
import { pageSaga } from "./pageSaga";
import { postSaga } from "./postSaga";
import { ratingSaga } from "./ratingSaga";
import { reportSaga } from "./reportSaga";
import { settingSaga } from "./settingSaga";
import { ticketSaga } from "./ticketSaga";
import { siteInfoSaga } from './siteInfoSaga';
import { agentSaga } from './agentSaga';
import { emailTemplateSaga } from './emailTemplateSaga';
import { airportSaga } from './airportSaga';
import { fareRuleSaga } from './fareRuleSaga';
import { baggageSaga } from './baggageSaga';
import { vinWonderSaga } from './vinWonderSaga';
import { VinWonderTicketSaga } from './vinWonderTicketSaga';
import { vinWonderPriceSaga } from './vinWonderPriceSaga';
import { tourTicketSaga } from './tourTicketSaga';
import { rateSaga } from './rateSaga';
import { amenitySaga } from './amenitySaga';
import { couponSaga } from './couponSaga';
import { tagSaga } from './tagSaga';
import { promotionSaga } from './promotionSaga'
import { tourPropertySaga } from './tourPropertySaga'
import { campaignSaga } from './campaignSaga';
import { objectTypeSaga } from './objectTypeSaga';
import { ticketSoldSaga } from './ticketSoldSaga';
import { rateCodeSaga } from './rateCodeSaga';
import { redirectLinkSaga } from './redirectLinkSaga';
import { supplierCategorySaga } from './supplierCategorySaga';
import { configPHSSaga } from './configPHSSaga';
import { payAtHotelSaga } from './payAtHotelSaga';
import { markupBundleSaga } from './markupBundleSaga';
import { cashFlowSaga } from './cashFlowSaga';
import { recommendationSaga } from './recommendationSaga'
import { inventorySaga } from './inventorySaga'
import { pointChangeHistorySaga } from "./pointChangeHistorySaga";
import { bookablePackageRateSaga } from "./bookablePackageRateSaga";
import { packageRateSaga } from "./packageRateSaga";
import { bundleReportSaga } from './bundleReportSaga';
import {appUISaga} from './appUISaga'
import { homestaySaga } from './homestaySage';
import { homestayRoomTypeSaga } from './homestayRoomTypeSaga.js';
import { homestayRateSaga } from './homestayRateSaga';
import { vinwonderTagGroupSaga } from './vinwonderTagGroup';
import { golfSaga } from './golfSaga';
import { autoTranslateSaga } from './autoTranslateSaga';
import fnbSaga from './fnbSaga';
import { cacheRedisSaga } from './cacheRedisSaga';

export default function* rootSaga(){
    yield all([
        userSaga(),
        authSaga(),
        propertySaga(),
        uploadSaga(),
        bannerSaga(),
        tourSaga(),
        supplierSaga(),
        orderSaga(),
        customerSaga(),
        groupSaga(),
        groupCategorySaga(),
        productSaga(),
        voucherSaga(),
        roleSaga(),
        generalSaga(),
        roomTypeSaga(),
        homestayRoomTypeSaga(),
        locationSaga(),
        customPriceSaga(),
        hotelSaga(),
        homestaySaga(),
        popularPlaceSaga(),
        categorySaga(),
        pageSaga(),
        postSaga(),
        ratingSaga(),
        reportSaga(),
        settingSaga(),
        ticketSaga(),
        siteInfoSaga(),
        agentSaga(),
        emailTemplateSaga(),
        airportSaga(),
        fareRuleSaga(),
        baggageSaga(),
        vinWonderSaga(),
        VinWonderTicketSaga(),
        vinWonderPriceSaga(),
        tourTicketSaga(),
        rateSaga(),
        homestayRateSaga(),
        amenitySaga(),
        couponSaga(),
        tagSaga(),
        promotionSaga(),
        tourPropertySaga(),
        campaignSaga(),
        autoTranslateSaga(),
        objectTypeSaga(),
        ticketSoldSaga(),
        rateCodeSaga(),
        redirectLinkSaga(),
        supplierCategorySaga(),
        configPHSSaga(),
        payAtHotelSaga(),
        markupBundleSaga(),
        cashFlowSaga(),
        recommendationSaga(),
        inventorySaga(),
        pointChangeHistorySaga(),
        bookablePackageRateSaga(),
        packageRateSaga(),
        bundleReportSaga(),
        appUISaga(),
        vinwonderTagGroupSaga(),
        golfSaga(),
        cacheRedisSaga(),
        fnbSaga(),
    ])
}
